import {method} from './core';

export function callLeadGetAll(data) {
  return method('lead', data);
}

export function callLeadSetTags(id, tags) {
  return method('lead/tags', { id, tags });
}

export function callLeadEdit(data) {
  return method('lead/edit', data);
}

export function callLeadRemove(id) {
  return method('lead/remove', { id });
}



// WEBPACK FOOTER //
// ./src/helpers/api/lead.js